import Cookies from 'js-cookie';

export const saveSession = async ({
    userId,
    accessToken,
    refreshToken,
    expireInDays = 3,
    token
}: {
    userId: string;
    accessToken: string;
    refreshToken: number;
    expireInDays: number;
    token?: string;
}) => {

    const session = {
        userId,
        accessToken,
        refreshToken
    };

    Cookies.set('ultima-auth-session', JSON.stringify(session), { expires: (expireInDays || 3) });
    if (token) {
        localStorage.setItem('ultima-auth-jwt-session', String(token));
    }
    window.dispatchEvent(new Event('ultimaCheckSession'));
    setTimeout(() => {
        window.dispatchEvent(new Event('ultimaCheckSession'));
    }, 500)
};